import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Observable, tap } from 'rxjs';
import { getColors } from 'src/app/models/colors';
import { ScaleInUseService } from 'src/app/services/scale-in-use.service';

@Component({
  selector: 'app-popover-select-color',
  templateUrl: './popover-select-color.component.html',
  styleUrls: ['./popover-select-color.component.scss'],
})
export class PopoverSelectColorComponent  implements OnInit {

  constructor(
    private popoverCtrl: PopoverController,
    private scaleInUse: ScaleInUseService
  ) { }

  colorsSelected$!: Observable<string[]>;

  @Input() isSector!: boolean;
  @Input() scaleId!: number;

  colors: string[] = [];

  ngOnInit() {
    this.colorsSelected$ = this.scaleInUse.getColorsSelected().pipe(
      tap((r) => {
        this.colors = r;
      })
    )
  }

  getAllColors() {
    return getColors().filter(col => !this.isSelected(col));
  }

  isSelected(color: string) {
    return this.colors.includes(color);
  }

  setColor(name: string, isSelected: boolean) {
    if(isSelected) return;
    this.popoverCtrl.dismiss(name);
  }

}
